import { render, staticRenderFns } from "./order-detail-modal.vue?vue&type=template&id=38dcd2ce&scoped=true&"
import script from "./order-detail-modal.vue?vue&type=script&lang=js&"
export * from "./order-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dcd2ce",
  null
  
)

export default component.exports